/**
 * @ngdoc object
 * @name billing.invoices
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoices', [
        'ui.router',
        //'ngListView'
    ]);

require('./invoices-routes');

// Controllers
require('./controllers/create-modal-controller');
require('./controllers/details-controller');
require('./controllers/edit-modal-controller');
require('./controllers/list-controller');
require('./controllers/update-address-modal-controller');
require('./controllers/cancel-invoice-modal-controller');
require('./controllers/edit-meta-modal-controller');
require('./controllers/payments/create-modal-controller');
require('./controllers/payments/edit-modal-controller');
require('./controllers/modals/create-invoice-from-bid-controller');
require('./controllers/modals/create-invoice-from-commission-controller');
require('./controllers/modals/select-position-controller');
require('./controllers/modals/info-document-modal-controller');
require('./controllers/invoice-actions/vouchers-and-tickets-modal-controller');

// Directives
// require('./directives/invoices/invoices-directive');
require('./directives/invoice-payments/invoice-payments-directive');

// Stores
require('./store/invoices');
require('./store/payments');

// Services
require('./services/invoice-actions-service');
require('./services/payments-service');

// Factories
require('./factories/invoice-factory');
require('./factories/payment-factory');

//Workflows
require('./workflows/export-invoices');
require('./workflows/send-invoices');
require('./workflows/create-voucher-export-for-invoices');
require('./workflows/print-voucher-overviews-for-invoices');
require('./workflows/print-invoices');
require('./workflows/print-pickup-for-invoices');



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/invoices-module.js